import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslate } from '@awardit/react-use-translate';
import { CustomBreadcrumbs } from '../Breadcrumbs/index.js';
import { Button, Wrapper } from '@crossroads/ui-components';
import styles from 'shop-views/AdventCalendarHero.scss';

var AdventCalendarHero = _ref => {
  var _category$clsCatfield, _category$clsCatfield2, _category$clsCatfield3;

  var home = _ref.home,
      category = _ref.category,
      hasAlternativeHeroLayout = _ref.hasAlternativeHeroLayout,
      hasTotalCount = _ref.hasTotalCount;
  var t = useTranslate();
  var bannerImage = home !== null && home != null && home.adventCalendar && home.adventCalendar.category.clsCatfieldsGeneralImgL !== undefined && home.adventCalendar.category.clsCatfieldsGeneralImgL !== null ? home.adventCalendar.category.clsCatfieldsGeneralImgL : null;
  var totalCount = category != null && category.products ? category.products.totalCount : -1;
  var currentCategory = category != null && category.name ? category.name : "";
  var alternativeHeroLayoutBool = Boolean(hasAlternativeHeroLayout);

  if (alternativeHeroLayoutBool) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: styles.hero,
      style: bannerImage ? {
        background: `url(${bannerImage.x2}) 95% 0 / cover no-repeat`
      } : {}
    }), /*#__PURE__*/React.createElement("div", {
      className: styles.heroContent
    }, category !== null ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("h1", null, category.name), /*#__PURE__*/React.createElement("p", null, category.description), /*#__PURE__*/React.createElement(Link, {
      to: `/${t("ADVENT_CALENDAR.CATEGORY_URL")}`
    }, /*#__PURE__*/React.createElement(Button, {
      variant: "primary"
    }, t("ADVENT_CALENDAR.BACK")))) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("h1", null, t("ADVENT_CALENDAR.HERO.HEADING")), /*#__PURE__*/React.createElement("p", null, t("ADVENT_CALENDAR.HERO.TEXT")))));
  }

  return /*#__PURE__*/React.createElement(Wrapper, {
    className: styles.hero
  }, ((category == null ? void 0 : category.clsCatfieldsGeneralImgS) || (category == null ? void 0 : category.clsCatfieldsGeneralImgM) || (category == null ? void 0 : category.clsCatfieldsGeneralImgL)) && /*#__PURE__*/React.createElement("div", {
    className: styles.banner
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.bannerSmall,
    style: {
      backgroundImage: `url(${((_category$clsCatfield = category.clsCatfieldsGeneralImgS) == null ? void 0 : _category$clsCatfield.x2) || ""})`
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.bannerMedium,
    style: {
      backgroundImage: `url(${((_category$clsCatfield2 = category.clsCatfieldsGeneralImgM) == null ? void 0 : _category$clsCatfield2.x2) || ""})`
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.bannerLarge,
    style: {
      backgroundImage: `url(${((_category$clsCatfield3 = category.clsCatfieldsGeneralImgL) == null ? void 0 : _category$clsCatfield3.x2) || ""})`
    }
  })), /*#__PURE__*/React.createElement(CustomBreadcrumbs, {
    className: styles.breadcrumbs,
    links: [{
      title: t("ADVENT_CALENDAR.TEXT"),
      pathname: `/${t("ADVENT_CALENDAR.CATEGORY_URL")}`
    }],
    current: currentCategory
  }), Boolean(hasTotalCount) && /*#__PURE__*/React.createElement("div", {
    className: styles.totalCount
  }, totalCount === 0 && t("ADVENT_CALENDAR.TOTAL_COUNT_EMPTY"), totalCount === 1 && t("ADVENT_CALENDAR.TOTAL_COUNT_SINGULAR"), totalCount > 1 && t("ADVENT_CALENDAR.TOTAL_COUNT_PLURAL", {
    totalCount
  })));
};

export { AdventCalendarHero };
//# sourceMappingURL=index.js.map
